import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayers = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 35.981,
	viewBox: "0 0 36.457 35.981",
	width: 36.457,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		transform: "translate(-201.804 -1595.995)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m220.032 1597-16.85 10.548 16.85 10.548 16.85-10.548z" }),
			/* @__PURE__ */ _jsx("path", { d: "m203.182 1613.986 16.85 10.548 16.85-10.548" }),
			/* @__PURE__ */ _jsx("path", { d: "m203.182 1620.428 16.85 10.548 16.85-10.548" })
		]
	})
});
export default SvgLayers;
